import { useFormHandler } from ".";
import { useI18n } from "../contexts";
function formContentBlockerAttributesFromTemplate(template) {
    const result = {
        name: template == null ? void 0 : template.name,
        description: template == null ? void 0 : template.description,
        rules: template == null ? void 0 : template.consumerData.rules.join("\n"),
        services: template == null ? void 0 : template.consumerData.serviceTemplates.map((param)=>{
            let { consumerData: { id } } = param;
            return id;
        }).filter(Boolean),
        tcfVendors: template == null ? void 0 : template.consumerData.tcfVendorConfigurations.map((param)=>{
            let { vendorConfigurationId } = param;
            return vendorConfigurationId === false ? undefined : vendorConfigurationId;
        }).filter(Boolean),
        isVisual: template == null ? void 0 : template.isVisual,
        visualType: template == null ? void 0 : template.visualType,
        visualContentType: template == null ? void 0 : template.visualContentType,
        isVisualDarkMode: template == null ? void 0 : template.isVisualDarkMode,
        visualBlur: template == null ? void 0 : template.visualBlur,
        visualHeroButtonText: template == null ? void 0 : template.visualHeroButtonText,
        shouldForceToShowVisual: template == null ? void 0 : template.shouldForceToShowVisual
    };
    // Remove undefined and nulled values as the result of this function should only contain
    // real values so it can be used e.g. with `Object.assign`.
    for(const key in result){
        if (result[key] === undefined || result[key] === null) {
            delete result[key];
        }
    }
    return result;
}
function useFormContentBlockerHandler(opts) {
    var _attributes_tcfVendors, _attributes_tcfPurposes;
    const { __ } = useI18n();
    const { isTcf, isEdit, template, attributes } = opts;
    const defaultValues = {
        name: "",
        status: "publish",
        description: "",
        rules: "",
        criteria: isTcf && (template == null ? void 0 : template.tcfVendorIds.length) ? "tcfVendors" : "services",
        tcfVendors: (attributes == null ? void 0 : (_attributes_tcfVendors = attributes.tcfVendors) == null ? void 0 : _attributes_tcfVendors.filter(Number)) || [],
        // Always add "Store and/or access information on a device" as this is the most-friendly option
        // to the website operator, which covers not to load the embedded content without consent
        tcfPurposes: (attributes == null ? void 0 : (_attributes_tcfPurposes = attributes.tcfPurposes) == null ? void 0 : _attributes_tcfPurposes.filter(Number)) || [
            1
        ],
        services: [],
        isVisual: true,
        visualType: "default",
        visualMediaThumbnail: 0,
        visualContentType: "generic",
        isVisualDarkMode: false,
        visualBlur: 0,
        visualDownloadThumbnail: undefined,
        visualHeroButtonText: "",
        shouldForceToShowVisual: false,
        templateCheck: !template,
        succeessorDeletionCheck: (template == null ? void 0 : template.consumerData.successorOf.length) > 0 && !isEdit,
        ...formContentBlockerAttributesFromTemplate(template),
        ...attributes || {}
    };
    const handlers = useFormHandler({
        ...opts,
        defaultValues,
        i18n: {
            successMessage: __("You have successfully saved the content blocker."),
            validationError: __("The content blocker could not be saved due to missing/invalid form values."),
            unloadConfirm: __("You have unsaved changes. If you leave this page, your changes will be discarded."),
            unloadConfirmInitialActive: __("You have already created a service. Are you sure that you don't want to create the corresponding content blocker?")
        }
    });
    const { isTemplateUpdate, templateCheck } = handlers;
    // Find non-existing services and show a warning
    const nonExistingServices = (template == null ? void 0 : template.consumerData.serviceTemplates.filter((param)=>{
        let { consumerData: { isCreated } } = param;
        return !isCreated;
    })) || [];
    // Find non-existing TCF vendors and show a warning
    const nonExistingTcfVendors = (template == null ? void 0 : template.consumerData.tcfVendorConfigurations.filter((param)=>{
        let { vendorConfigurationId } = param;
        return vendorConfigurationId === false;
    })) || [];
    return {
        ...handlers,
        template,
        nonExistingServices,
        nonExistingTcfVendors,
        contextValue: {
            isTcf,
            isEdit,
            template,
            isTemplateUpdate,
            templateCheck,
            defaultTemplateValues: template ? defaultValues : {}
        }
    };
}
export { useFormContentBlockerHandler, formContentBlockerAttributesFromTemplate };
